import React from "react";

export const Saint = ({size = 20, ...props}) => {
	return (
		<svg
			height={size}
			viewBox="0 0 512 512"
			width={size}
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M161.697 318.179c0-32.38-26.255-58.63-58.641-58.63s-58.641 26.249-58.641 58.63c0 23.152 13.426 43.163 32.914 52.693-64.996 19.17-75.854 88.79-77.211 122.535l65.887 9 66.006-9 29.699-163.34z"
				fill="#888089"
			/>
			<path
				d="M.033 507.155A4.998 4.998 0 005.034 512h126.977l9.007-9.297-9.007-9.297H.119s-.194 10.247-.086 13.749z"
				fill="#7b757c"
			/>
			<path
				d="M350.303 318.179c0-32.38 26.254-58.63 58.641-58.63 32.386 0 58.641 26.249 58.641 58.63 0 23.152-13.426 43.163-32.914 52.693 64.996 19.17 75.854 88.79 77.211 122.535l-65.887 9-66.006-9-29.699-163.34z"
				fill="#888089"
			/>
			<path
				d="M511.967 507.155a4.999 4.999 0 01-5.002 4.845H379.988l-9.007-9.297 9.007-9.297H511.88c.001 0 .195 10.247.087 13.749z"
				fill="#7b757c"
			/>
			<path
				d="M380.259 493.406v-94.045l-211.61-75.302c-22.309 17.517-36.638 44.725-36.638 75.276v94.071l124.513 9z"
				fill="#eeeff4"
			/>
			<path
				d="M132.012 512H173.3l7.747-9 7.748 9h134.681l7.747-9 7.748 9h41.288v-18.594H132.012z"
				fill="#e5e6ea"
			/>
			<path
				d="M178.224 317.435c18.38 38.913 120.411 86.001 200.221 63.323-8.663-43.952-47.407-77.102-93.9-77.102h-56.818c-5.186 0-10.274.43-15.236 1.224l-4.082 6.092-12.519-1.893a95.266 95.266 0 00-17.666 8.356c-.001 0 0 0 0 0z"
				fill="#ff748f"
			/>
			<path
				d="M292.659 356.932a7.75 7.75 0 008.887-6.408 7.747 7.747 0 00-6.409-8.887c-35.086-5.686-56.887-16.848-68.999-25.21-6.371-4.4-10.788-8.499-13.648-11.548a95.08 95.08 0 00-16.6 4.2c4.952 7.046 29.572 36.965 96.769 47.853z"
				fill="#e8587b"
			/>
			<path
				d="M154.8 213.972s-31.137-75.9 42.774-121.846c51.324-31.905 94.628-.673 94.628-.673s105.732-13.944 65.27 122.52H154.8z"
				fill="#dfaa88"
			/>
			<path
				d="M171.528 245.987l6.706-9.09 10.849-15.906-10.88-17.182a26.213 26.213 0 00-2.687-.138c-11.074 0-20.524 6.928-24.265 16.684.001 14.957 9.203 25.632 20.277 25.632z"
				fill="#edbca4"
			/>
			<path
				d="M175.517 237.038c-11.074 0-20.524-6.928-24.265-16.684a25.911 25.911 0 00-1.72 9.297c0 14.349 11.634 25.98 25.986 25.98 1.815 0 3.587-.187 5.298-.542l7.233-8.639-9.814-9.555c-.894.095-1.8.143-2.718.143z"
				fill="#eaab92"
			/>
			<path
				d="M340.607 245.987l-6.706-9.09-10.849-15.906 10.88-17.182c.883-.091 1.78-.138 2.687-.138 11.074 0 20.523 6.928 24.265 16.684 0 14.957-9.203 25.632-20.277 25.632z"
				fill="#edbca4"
			/>
			<path
				d="M336.618 237.038c11.074 0 20.524-6.928 24.265-16.684a25.911 25.911 0 011.72 9.297c0 14.349-11.634 25.98-25.985 25.98a26.05 26.05 0 01-5.298-.542l-7.233-8.639 9.814-9.555c.893.095 1.8.143 2.717.143z"
				fill="#eaab92"
			/>
			<path d="M256.135 312.953l-.068-.002-.068.002z" fill="#f9c6aa" />
			<g fill="#ffd6bd">
				<path d="M256.135 294.359l-.068-.002-.068.002z" />
				<path d="M256.068 303.358c43.009-.037 77.864-32.316 77.864-86.915v-12.634c-28.923-20.107-41.166-45.969-45.734-58.776-1.23-3.448-5.615-4.437-8.223-1.868-41.178 40.552-101.77 60.644-101.77 60.644v12.636c-.001 55.807 34.854 86.876 77.863 86.913z" />
			</g>
			<path
				d="M256.132 268.426c7.995 15.334 25.747 10.109 32.905 7.208a5.007 5.007 0 003.139-4.829c-.326-8.667-4.276-30.715-36.041-30.715s-35.715 22.049-36.041 30.715a5.005 5.005 0 003.139 4.829c7.159 2.9 24.91 8.126 32.905-7.208z"
				fill="#dfaa88"
			/>
			<g fill="#f9c6aa">
				<path d="M256.135 312.953l-.068-.002-.068.002z" />
				<path d="M333.931 216.443c0 43.01-34.855 77.878-77.864 77.915l.068.002H256l.068-.002c-43.009-.037-77.864-34.905-77.864-77.915v18.594c0 43.01 34.855 77.878 77.864 77.915 43.009-.037 77.864-34.905 77.864-77.915v-18.594z" />
			</g>
			<path
				d="M178.224 317.435c-3.33 2.016-9.574 6.624-9.574 6.624s43.489 75.629 211.61 75.303c0-6.366-.628-12.585-1.815-18.603-124.498-.168-180.082-42.121-200.221-63.324z"
				fill="#ff577f"
			/>
			<path
				d="M188.795 493.406v-67.421a7.747 7.747 0 00-7.748-7.747 7.747 7.747 0 00-7.747 7.747v67.421l7.747 9.297zM338.971 493.406v-67.421a7.747 7.747 0 00-7.748-7.747 7.748 7.748 0 00-7.748 7.747v67.421l7.748 9.297z"
				fill="#e1e1e5"
			/>
			<g fill="#d1d1d3">
				<path d="M173.3 493.406h15.495V512H173.3zM323.476 493.406h15.495V512h-15.495z" />
			</g>
			<g>
				<path
					d="M218.309 236.249a7.762 7.762 0 007.762-7.763v-17.502a7.763 7.763 0 10-15.524 0v17.502a7.762 7.762 0 007.762 7.763zM293.976 236.249a7.762 7.762 0 007.762-7.763v-17.502a7.763 7.763 0 10-15.524 0v17.502a7.762 7.762 0 007.762 7.763z"
					fill="#888089"
				/>
				<path
					d="M195.625 45.623c16.35 3.457 37.978 5.361 60.9 5.361s44.549-1.904 60.899-5.361c13.187-2.788 30.717-7.908 30.717-20.131S330.61 8.149 317.424 5.361C301.075 1.904 279.447 0 256.525 0s-44.55 1.904-60.9 5.36c-13.187 2.788-30.717 7.908-30.717 20.131 0 12.224 17.53 17.344 30.717 20.132zm60.9-30.098c40.144 0 65.472 5.799 73.87 9.966-8.398 4.167-33.726 9.966-73.87 9.966s-65.473-5.799-73.871-9.966c8.398-4.167 33.727-9.966 73.871-9.966z"
					fill="#f9f097"
				/>
				<path
					d="M279.401 433.668h-15.114v-16.335a7.763 7.763 0 10-15.524 0v16.335h-15.114a7.762 7.762 0 00-7.762 7.763 7.762 7.762 0 007.762 7.762h15.114v27.773a7.763 7.763 0 1015.524 0v-27.773h15.114a7.762 7.762 0 007.762-7.762 7.761 7.761 0 00-7.762-7.763z"
					fill="#dfaa88"
				/>
			</g>
		</svg>
	);
}

export default Saint;
